import session from './session'

const uri = process.env.API_ENDPOINT

export default {
  getReminderList(params) {
    return session.get(uri + '/api/cl/reminder_list/', { params })
  },

  stopReminder(reminderId) {
    return session.put(uri + `/api/cl/reminder/${reminderId}/stop/`)
  },

  deleteReminder(reminderId) {
    return session.delete(uri + `/api/cl/reminder/${reminderId}/`)
  }
}


// WEBPACK FOOTER //
// ./src/api/schedule.js